type Brand<T, B extends string> = T & { readonly __brand: B };

export type UUID = Brand<string, "UUID">;
export type AddressId = Brand<UUID, "AddressId">;
export type ClientId = Brand<UUID, "ClientId">;
export type ConstructionSiteId = Brand<UUID, "ConstructionSiteId">;
export type JobId = Brand<UUID, "JobId">;
export type PersonId = Brand<UUID, "PersonId">;
export type EventId = Brand<UUID, "EventId">;
export type AttachmentId = Brand<UUID, "AttachmentId">;

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const asUUID = (s: string) => {
  if (!UUID_RE.test(s)) throw new Error("Invalid UUID");
  return s as UUID;
};
export const asAddressId = (s: string) => asUUID(s) as AddressId;
export const asClientId = (s: string) => asUUID(s) as ClientId;
export const asConstructionSiteId = (s: string) =>
  asUUID(s) as ConstructionSiteId;
export const asJobId = (s: string) => asUUID(s) as JobId;
export const asPersonId = (s: string) => asUUID(s) as PersonId;
export const asEventId = (s: string) => asUUID(s) as EventId;
export const asAttachmentId = (s: string) => asUUID(s) as AttachmentId;
